import React, { useState } from 'react'
import { MDBBtn } from 'mdb-react-ui-kit'

const ChannelSubscriber = ({ subscribed, onSubscribe, onUnsubscribe, disabled }) => {
  const [name, setName] = useState('')
  const [visibility, setVisibility] = useState('private')

  const handleSubscribe = e => {
    e.preventDefault()
    if (!name.trim()) return
    onSubscribe(name.trim(), visibility)
    setName('')
  }

  return (
    <div className='ws-card'>
      <h5>Channel Subscriptions</h5>
      <form onSubmit={handleSubscribe}>
        <div className='form-row align-items-end'>
          <div className='col-12 col-md-6'>
            <label className='small mb-1'>Channel name (no visibility prefix)</label>
            <input
              type='text'
              className='form-control form-control-sm'
              placeholder='diagnostics.agent.42'
              value={name}
              onChange={e => setName(e.target.value)}
              disabled={disabled}
            />
          </div>
          <div className='col-6 col-md-3'>
            <label className='small mb-1'>Visibility</label>
            <select
              className='form-control form-control-sm'
              value={visibility}
              onChange={e => setVisibility(e.target.value)}
              disabled={disabled}
            >
              <option value='public'>public</option>
              <option value='private'>private</option>
              <option value='presence'>presence</option>
            </select>
          </div>
          <div className='col-6 col-md-3'>
            <MDBBtn type='submit' size='sm' color='primary' className='w-100' disabled={disabled}>
              Subscribe
            </MDBBtn>
          </div>
        </div>
      </form>

      <ul className='ws-subscribed-list'>
        {subscribed.length === 0 && <li className='text-muted'>No active subscriptions.</li>}
        {subscribed.map(s => (
          <li key={`${s.visibility}:${s.name}`}>
            <span>
              <strong>{s.visibility}-</strong>
              {s.name}
            </span>
            <button
              type='button'
              className='btn btn-outline-danger btn-sm'
              onClick={() => onUnsubscribe(s.name, s.visibility)}
            >
              Unsubscribe
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ChannelSubscriber
